import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/mineralImport';

const initialState = fromJS({
  mineralImports: { data: [], state: null },
  mineralImportTypes: [],
  mineralImportValidationErrors: { data: [], state: null },
  errorDetails: {
    data: [],
    state: null,
  },
  mineralImportMatches: { data: [], state: null },
  matchedDetails: { data: [], state: null },
});

const MineralImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_MINERAL_IMPORTS[START]: {
      return state.setIn(['mineralImports', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORTS[SUCCESS]: {
      return state
        .setIn(['mineralImports', 'state'], fetchingState.LOADED)
        .setIn(
          ['mineralImports', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_MINERAL_IMPORTS[ERROR]: {
      return state.setIn(['mineralImports', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_TYPES[SUCCESS]: {
      return state.setIn(
        ['mineralImportTypes'],
        fromJS(action.data ? action.data.results : []),
      );
    }

    case actions.FETCH_MINERAL_IMPORT_VALIDATION_ERRORS[START]: {
      return state.setIn(
        ['mineralImportValidationErrors', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_MINERAL_IMPORT_VALIDATION_ERRORS[SUCCESS]: {
      return state
        .setIn(['mineralImportValidationErrors', 'state'], fetchingState.LOADED)
        .setIn(
          ['mineralImportValidationErrors', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_MINERAL_IMPORT_VALIDATION_ERRORS[ERROR]: {
      return state.setIn(
        ['mineralImportValidationErrors', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS[START]: {
      return state.setIn(['errorDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS[SUCCESS]: {
      return state
        .setIn(['errorDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['errorDetails', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS[ERROR]: {
      return state.setIn(['errorDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_MATCHED_AGENTS[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_MATCHED_AGENTS[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_MATCHED_AGENTS[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_MATCHED_OWNERS[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_MATCHED_OWNERS[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_MATCHED_OWNERS[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_NEW_PROPERTIES[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_NEW_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_NEW_PROPERTIES[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_NEW_AGENTS[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_NEW_AGENTS[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_NEW_AGENTS[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_NEW_OWNERS[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_NEW_OWNERS[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_NEW_OWNERS[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_ERROR_PROPERTIES[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_ERROR_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_ERROR_PROPERTIES[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_ERROR_AGENTS[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_ERROR_AGENTS[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_ERROR_AGENTS[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_ERROR_OWNERS[START]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MINERAL_IMPORT_ERROR_OWNERS[SUCCESS]: {
      return state
        .setIn(['matchedDetails', 'state'], fetchingState.LOADED)
        .setIn(['matchedDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_ERROR_OWNERS[ERROR]: {
      return state.setIn(['matchedDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_MINERAL_DETAILS[START]: {
      return state.setIn(['mineralDetails', 'state'], fetchingState.FETCHING);
    }   
    case actions.FETCH_MINERAL_IMPORT_MINERAL_DETAILS[SUCCESS]: {
      return state
        .setIn(['mineralDetails', 'state'], fetchingState.LOADED)
        .setIn(['mineralDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_MINERAL_DETAILS[ERROR]: {
      return state.setIn(['mineralDetails', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_MINERAL_IMPORT_DELETED_DETAILS[START]: {
      return state.setIn(['mineralDetails', 'state'], fetchingState.FETCHING);
    }   
    case actions.FETCH_MINERAL_IMPORT_DELETED_DETAILS[SUCCESS]: {
      return state
        .setIn(['mineralDetails', 'state'], fetchingState.LOADED)
        .setIn(['mineralDetails', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_MINERAL_IMPORT_DELETED_DETAILS[ERROR]: {
      return state.setIn(['mineralDetails', 'state'], fetchingState.ERROR);
    } 

    default: {
      return state;
    }
  }
};

export default MineralImportReducer;
